import { useMobxStores } from '@stores/index';
import { Rate } from 'antd';
import dayjs from 'dayjs';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { CheckCircleOutlined } from './Icons';
import LoadMoreBtn from './LoadMoreBtn';

function Reviews({ facility, reviews }) {
  const { reservationStore } = useMobxStores();

  useEffect(() => {
    reservationStore.loadReviews(facility.facility_id);
  }, [reservationStore, facility]);

  return (
    <div>
      <div className="border-b"></div>
      <ul className="flex flex-col">
        {reservationStore.reviewsList?.map((review) => (
          <>
            <li key={review.id} className="py-4 grid grid-cols-1 border-b">
              <div className="flex flex-col">
                <div className="flex flex-row justify-between">
                  <h4>{review.member_email}</h4>
                  <time className="font-normal text-xs">
                    {dayjs(review.dt_review).format('MM/DD/YYYY')}
                  </time>
                </div>
                <Rate
                  disabled
                  value={review.review_grade}
                  className="text-base"
                />

                <span className="table text-base">{review.review_comment}</span>
              </div>
            </li>

            {review.review_reply && (
              <>
                <li className="px-3 md:px-4 py-3 md:py-4 grid grid-cols-1 my-4 border-b">
                  <div className="grid grid-cols-1 md:grid-cols-2">
                    <h4 className="font-semibold">Your On Air Parking team</h4>
                  </div>
                  <time>
                    {dayjs(review.dt_review_reply).format('MM/DD/YYYY')}
                  </time>
                  <span className="table text-base">{review.review_reply}</span>
                </li>
              </>
            )}

            {review.review_partner_reply && (
              <li className="px-3 md:px-4 py-3 md:py-4 grid grid-cols-1 mb-4 border-b">
                <div className="grid grid-cols-1 md:grid-cols-2">
                  <h4 className="font-semibold">Facility Manager</h4>
                </div>
                <time>
                  {dayjs(review.dt_review_partner_reply).format('MM/DD/YYYY')}
                </time>
                <span className="table text-base">
                  {review.review_partner_reply}
                </span>
              </li>
            )}
          </>
        ))}
      </ul>

      <div className="flex flex-col md:flex-row justify-center gap-4 pb-8 ">
        <LoadMoreBtn facility_id={facility.facility_id} />
      </div>
    </div>
  );
}

export default observer(Reviews);
